import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface AuthState {
  oAuthToken: string | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  user: string | null;
  isCorporateSelectRequired?: boolean;
}

const initialState: AuthState = {
  oAuthToken: null,
  accessToken: null,
  isAuthenticated: false,
  user: null,
  isCorporateSelectRequired: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setoAuthAccessToken(state, action: PayloadAction<string>) {
      state.oAuthToken = action.payload;
    },
    setAccessToken(state, action: PayloadAction<any>) {
      state.accessToken = action.payload;
    },
    setIsAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    logout(state) {
      state.oAuthToken = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.user = null;
    },
    setCorporateSelection(state, action: PayloadAction<boolean>) {
      state.isCorporateSelectRequired = action.payload;
    }
  },
});

export const {
  setoAuthAccessToken,
  setAccessToken,
  setIsAuthenticated,
  logout,
  setCorporateSelection
} = authSlice.actions;
export default authSlice.reducer;

// Selectors to get tokens from auth state
export const selectoAuthToken = (state: RootState) => state.auth.oAuthToken;
export const selectAccessToken = (state: RootState) => state.auth.accessToken;
export const selectCorporateSelectionRequired = (state: RootState) => state.auth.isCorporateSelectRequired;
